module.exports = __webpack_public_path__ + "img/fb-footer.e79235bb.svg";